import React, { useState, useEffect } from 'react';
import {
  AutocompleteArrayInput,
  FormDataConsumer,
  SelectArrayInput,
  useTranslate,
} from 'react-admin';

const ReferenceArrayChild = (props) => {
  const [initialChoices, setInitialChoices] = useState(null);
  const {
    optionText,
    source,
    choices,
    setFilter,
    className,
    translateChoice,
    helperText,
    onChange,
    resource,
  } = props;
  // useEffect will help to prevent the swap of autocomplete to selecinput during query search result less than 20
  useEffect(() => {
    if (initialChoices < choices.length) {
      setInitialChoices((prevState) =>
        prevState < choices.length ? choices.length : prevState,
      );
    }
  }, [choices, initialChoices]);
  const translate = useTranslate();
  return (
    <FormDataConsumer source={source}>
      {({ formData, ...rest }) => {
        const inputProps = { ...rest };
        if (resource) {
          inputProps.label = translate(
            `resources.${resource}.fields.${source}`,
          );
        }
        if (initialChoices && initialChoices <= 20) {
          return (
            <SelectArrayInput
              {...inputProps}
              choices={choices}
              optionText={optionText}
              source={source}
              className={className}
              translateChoice={translateChoice}
              helperText={helperText}
              onChange={onChange}
            />
          );
        }
        return (
          <AutocompleteArrayInput
            {...inputProps}
            choices={choices}
            optionText={optionText}
            source={source}
            setFilter={setFilter}
            className={className}
            translateChoice={translateChoice}
            helperText={helperText}
            onChange={onChange}
          />
        );
      }}
    </FormDataConsumer>
  );
};

export default ReferenceArrayChild;
